import {Button, Loader, YStack} from "@chayka/ui";
import {DrawerMenu, Pass, CommonArea} from "@/components";
import {useAuth} from "@/hooks/useAuth";
import {StickyHeader} from "@chayka/ui";
import {NewsPreview} from "./ui/NewsPreview";
import {List} from "../MyBookings/components";
import {useQuery} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";
import {useNavigate} from "react-router-dom";

export const MainPageAuthorized = () => {
  const {user} = useAuth();
  const {data: bookings, isLoading: bookingsLoading} = useQuery(trpc.booking.list.queryOptions({}));
  const navigate = useNavigate();

  return (
    <>
      <StickyHeader />
      <DrawerMenu />
      <YStack className="items-start justify-center self-stretch gap-4">
        <h1 className="text-xl font-bold">
          Привет, {user?.firstName === "" ? user?.displayName : user?.firstName}!
        </h1>
        <Pass />
      </YStack>
      <NewsPreview />
      {bookingsLoading ? (
        <YStack className="justify-center items-center">
          <Loader />
        </YStack>
      ) : bookings?.length ? (
        <List data={bookings?.slice(0, 3)} />
      ) : (
        <Button onClick={() => navigate("/app/booking")}>Забронировать</Button>
      )}
      <CommonArea />
    </>
  );
};
